import createMaintenanceService from "./createMaintenanceService";

export default createMaintenanceService("/maintenance/tax-schedules");
